import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'
import { SystemSS } from '../../components/SystemSS'

export const ButtleFlowStep2 = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 0 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            <section>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='gameflow button'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-step2.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5 mx-auto mt-12'>
                    <p className=' '>
                        <span className='text-pborange'>All of Marona's allies are Phantoms.</span> By using the{' '}
                        <span className='text-pborange'>Confine</span> command, Marona can summon them to participate in
                        battle!
                    </p>
                    <p className='mt-8'>
                        Once the battle has begun, select Marona's <span className='text-pborange'>Confine</span>{' '}
                        ability to Confine your allies into the
                        <span className='text-pborange'> trees, flowers, rocks</span>, etc. present on the map.
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'flow-2',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description='Confine is a special technique that can only be used by Marona. There is no limit to how
                            many times Confine can be used, and Marona can use it anytime it is her turn.'
                    />{' '}
                    <p className=' '>
                        <span className='text-pborange'>
                            Depending on what kind of item your ally is Confined in, their stats will change.
                        </span>{' '}
                        Because of this, it's helpful to check the <span className='text-pborange'>icon</span> that's
                        displayed on the item when Confining your allies. That way, you'll be able to see at a glance
                        what stats are affected.
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'flow-2',
                                index: 2,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description=' If you Confine Ash in this flower with the INT icon...'
                    />{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'flow-2',
                                index: 3,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description='...his INT stat will go up!'
                    />{' '}
                    <p className=' '>
                        Allied Phantoms have a <span className='text-pborange'>set number of turns</span>. Be sure to
                        think about <span className='text-pborange'>when and where</span> to Confine them while
                        considering the number of turns they have on the map.
                    </p>{' '}
                    <p className=' '>
                        If needed, you can use Marona's skill <span className='text-pborange'>Confight</span> to{' '}
                        <span className='text-pborange'>
                            increase the number of turns an ally can remain on the map
                        </span>{' '}
                        before they are Removed!
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'flow-2',
                                index: 4,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                        description="Use Marona's ability to increase your allies' number of turns on the battlefield."
                    />{' '}
                </div>
                <FullScreenModal
                    showModal={showModal}
                    modalContent={modalContent}
                    setModalImage
                    handleCloseModal={handleCloseModal}
                    setModalContent={setModalContent}
                    maxIndex={4}
                />
            </section>
        </>
    )
}
